<template>
  <div class="c-list-box">
    <ul class="c-list-nav">
      <li class="c-list-title">发薪审核</li>
    </ul>
    <ul class="c-list-search">
      <c_statusradiogroup
        v-model="state.params.type"
        arrName="salaryapply_step"
        @change="onLoad"
      ></c_statusradiogroup>
      <el-radio-group v-model="state.params.is_arrearage" @change="onLoad">
        <el-radio-button>全部</el-radio-button>
        <el-radio-button :value="1">欠款发放</el-radio-button>
        <el-radio-button :value="0">非欠款发放</el-radio-button>
      </el-radio-group>
      <li style="width: 50%">
        <c_statusradiogroup
          v-model="state.params.status"
          arrName="salaryapply_status"
          @change="onLoad"
        ></c_statusradiogroup>
      </li>
      <el-input
        v-model="state.params.keywords"
        style="width: 200px"
        placeholder="--关键字--"
        clearable
        @clear="
          delete state.params.keywords;
          onLoad();
        "
        @paste.enter="$onKeywordsPaste($event, state.params)"
      ></el-input>
      <el-input
        v-model="state.params.keywords_employee"
        style="width: 200px"
        placeholder="员工姓名、手机号、证件号"
        clearable
        @clear="
          delete state.params.keywords_employee;
          onLoad();
        "
        @paste.enter="
          $onKeywordsPaste($event, state.params, 'keywords_employee')
        "
      ></el-input>
      <li style="width: 300px">
        <el-date-picker
          v-model="state.dates"
          type="daterange"
          range-separator="至"
          start-placeholder="到账日期"
          end-placeholder="到账日期"
          style="width: 100%"
          @change="
            (value) => {
              if (value) state.params.pay_date = value[0] + ' - ' + value[1];
            }
          "
          @clear="
            delete state.dates;
            delete state.params.pay_date;
          "
        />
      </li>
      <el-select
        v-model="state.params.customer_id"
        placeholder="所属客户"
        style="width: 240px"
      >
        <el-option
          v-for="item in state.customerData"
          :key="item.id"
          :label="item.name"
          :value="item.id"
        />
        <template #footer>
          <el-button size="small" @click="onLoadCustomer()">刷新</el-button>
        </template>
      </el-select>
      <c_withholdingagentselect
        @confirm="
          (ids) => {
            state.params.withholding_agent_id = ids;
          }
        "
      ></c_withholdingagentselect>
      <el-dropdown split-button @click="onLoad" type="primary">
        查询
        <template #dropdown>
          <el-dropdown-menu>
            <el-dropdown-item :icon="RefreshLeft" @click="onReset()">
              重置
            </el-dropdown-item>
          </el-dropdown-menu>
        </template>
      </el-dropdown>
    </ul>
    <ul class="c-list-table">
      <el-table
        :data="state.tableData"
        v-loading="!Array.isArray(state.tableData)"
        element-loading-background="rgba(0, 0, 0, 0.2)"
        :default-sort="{
          prop: state.params.sort_field,
          order: state.params.sort_value == 'desc' ? 'descending' : 'ascending',
        }"
        @sort-change="onSortChange"
      >
        <el-table-column
          fixed
          label="序号"
          width="70"
          type="index"
          :index="
            (index) => (state.params.page - 1) * state.params.limit + index + 1
          "
          align="center"
        />
        <el-table-column
          label="状态/进度"
          sortable="collected_status"
          width="120"
        >
          <template #default="{ row }">
            <c_tabgroup>
              <template #top>
                <component
                  :is="$statusFormat2('salaryapply_status', row.status)"
                />
              </template>
              <template #bottom>
                <component
                  v-if="row.is_arrearage == 0"
                  :is="$statusFormat2('salaryapply_step', row.step)"
                />
                <component
                  v-else
                  :is="$statusFormat2('salaryapply_step_qk', row.step)"
                />
              </template>
            </c_tabgroup>
          </template>
        </el-table-column>
        <el-table-column label="单号/名称" min-width="160">
          <template #default="{ row }">
            <c_tabgroup :value2="row.name">
              <template #top>
                <div
                  v-if="row.is_arrearage === 1"
                  data-type="欠"
                  :style="{
                    '--dynamic-color': '#ffa500',
                  }"
                  class="withholding-badge"
                  :title="row.order_id"
                >
                  {{ row.order_id }}
                </div>
                <text :title="row.order_id" v-else>
                  {{ row.order_id }}
                </text>
              </template>
            </c_tabgroup>
          </template>
        </el-table-column>
        <el-table-column
          prop="customer_name"
          label="所属客户"
          :formatter="$tab_TextFormat"
          min-width="220"
        />
        <el-table-column prop="payroll_order_id" label="工资表单号">
          <template #default="{ row }">
            <text
              style="color: #1e90ff"
              class="text-hover-decoration"
              title="工资表单号"
              @click="$onCopy(row.payroll_order_id)"
            >
              {{ row.payroll_order_id }}
            </text>
          </template>
        </el-table-column>
        <el-table-column
          prop="month"
          label="薪资所属期"
          :formatter="$tab_TextFormat"
          align="center"
        />
        <el-table-column
          prop="pay_date"
          label="发放日期"
          :formatter="$tab_TextFormat"
          align="center"
        />
        <el-table-column
          prop="money"
          label="本次发放金额"
          :formatter="$tab_PriceFormat"
          align="center"
        />
        <el-table-column
          prop="employee_num"
          label="本次发放数量"
          :formatter="$tab_NumberFormat"
          align="center"
        />
        <el-table-column label="申请人" width="160">
          <template #default="{ row }">
            <c_tabgroup
              :value1="row.add_admin_name || '-'"
              :value2="row.add_department_name"
            />
          </template>
        </el-table-column>
        <el-table-column
          label="操作"
          width="120"
          align="center"
          fixed="right"
          className="tabBtn"
        >
          <template #default="{ row }">
            <el-button
              type="primary"
              link
              icon="Select"
              v-if="
                row.status === 0 &&
                row.is_show_check_button &&
                $judge_auth('111')
              "
              @click="
                $store.commit('openMenu', {
                  path: 'SalaryApplyDetail',
                  title: '发薪单审核',
                  refresh: true,
                  data: {
                    id: row.id,
                  },
                })
              "
            >
              审核
            </el-button>
            <el-button
              type="primary"
              link
              icon="Search"
              v-else
              @click="
                $store.commit('openMenu', {
                  path: 'SalaryApplyDetail',
                  title: '发薪单详情',
                  refresh: true,
                  data: {
                    id: row.id,
                  },
                })
              "
            >
              查看
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <c_page
        :total="state.totalCount"
        :pageIndex="state.params.page"
        :pageSize="state.params.limit"
        @onLoad="
          (page) => {
            state.params.page = page.pageIndex;
            state.params.limit = page.pageSize;
            onLoad();
          }
        "
      />
    </ul>
  </div>
</template>

<script>
import { onMounted, reactive } from "vue";
import {
  data_withholdingagent_select,
  data_customer_select,
} from "@/http/data";
import { salaryapply_list } from "@/http/salaryapply";

class InitFormData {
  params = {
    limit: 20,
    page: 1,
  };
}
export default {
  props: {
    data: Object,
  },
  setup(props) {
    const state = reactive(new InitFormData());
    onMounted(() => {
      state.params.keywords = props.data?.keywords;

      onLoadWithholdingAgent();
      onLoadCustomer();
      onLoad();
    });

    const onLoad = () => {
      delete state.tableData;

      salaryapply_list(state.params).then((res) => {
        if (res.status == 200) {
          const { count, list } = res.data.data;
          state.tableData = list;
          state.totalCount = count;
        }
      });
    };

    //加载扣缴义务人
    const onLoadWithholdingAgent = () => {
      data_withholdingagent_select().then((res) => {
        if (res.status == 200)
          state.withholding_agent_data = res.data.data?.list;
      });
    };

    //获取客户
    const onLoadCustomer = () => {
      data_customer_select().then((res) => {
        if (res.status == 200) state.customerData = res.data.data?.list;
      });
    };

    const onDateChange = (value) => {
      if (value) state.params.pay_date = value[0] + " - " + value[1];
    };

    //排序
    const onSortChange = ({ column }) => {
      if (column.order) {
        state.params.sort_field = column.sortable;
        state.params.sort_value = column.order === "ascending" ? "asc" : "desc";
      } else {
        const params = new InitFormData().params;
        state.params.sort_field = params.Order;
        state.params.sort_value = "asc";
      }
      onLoad();
    };

    //重置查询条件
    const onReset = () => {
      Object.assign(state, new InitFormData());
      onLoad();
    };

    return {
      state,
      onLoad,
      onSortChange,
      onReset,
      onDateChange,
    };
  },
};
</script>
<style lang="less">
.bank-received-index-tab-pop {
  .el-descriptions__header {
    margin-bottom: 0 !important;
  }
}
</style>
